'use client'

import textHeadingM from '@fukku/styles/texts/textHeadingM.module.css'
import textInspirationalTitleL from '@fukku/styles/texts/textInspirationalTitleL.module.css'
import textInspirationalTitleXL from '@fukku/styles/texts/textInspirationalTitleXL.module.css'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import {
	type HeroBannerPromo,
	HeroBannerPromoType,
} from '../../../../Home.type'
import styles from './HeroBannerPromoProgressive.module.css'

interface HeroBannerPromoProgressiveProps {
	readonly section: HeroBannerPromo
}

export function HeroBannerPromoProgressive({
	section,
}: HeroBannerPromoProgressiveProps) {
	const { isLargeOrGreater } = useResponsive()
	if (section.promoType !== HeroBannerPromoType.progressive) {
		return null
	}

	const {
		progressivePromoTitles: { title1, strategy1, title2, strategy2 },
	} = section

	return (
		<div className={styles.titles}>
			<h2 className={styles.titlesWrapper}>
				<div
					className={
						isLargeOrGreater
							? textInspirationalTitleXL.className
							: textInspirationalTitleL.className
					}
				>
					{title1}
				</div>
				<div className={textHeadingM.className}>{strategy1}</div>
				<div
					className={
						isLargeOrGreater
							? textInspirationalTitleXL.className
							: textInspirationalTitleL.className
					}
				>
					{title2}
				</div>
				<div className={textHeadingM.className}>{strategy2}</div>
			</h2>
		</div>
	)
}
